import React, { type Dispatch, type SetStateAction } from 'react';

interface PassengerCounterProps {
  userChoice: { passengers: number };
  setUserChoice: Dispatch<SetStateAction<{ passengers: number }>>;
  maxPassengers?: number;
}

const PassengerCounter: React.FC<PassengerCounterProps> = ({ userChoice, setUserChoice, maxPassengers }) => {
  const incrementPassengers = () => {
    setUserChoice((prevState) => ({
      ...prevState,
      passengers: maxPassengers !== undefined ? Math.min(prevState.passengers + 1, maxPassengers) : prevState.passengers + 1
    }));
  };

  const decrementPassengers = () => {
    setUserChoice((prevState) => ({
      ...prevState,
      passengers: Math.max(1, prevState.passengers - 1)
    }));
  };

  return (
    <div className="bg-white border-2 border-ionic-border-light-gray flex items-center justify-between py-1 px-1 w-2/6 rounded-xl my-2 lg:w-2/5">
      <button
        onClick={decrementPassengers}
        className="text-white bg-ionic-primary rounded-lg p-1 w-8 h-8 flex items-center justify-center"
        aria-label="Decrease passenger count"
        disabled={userChoice.passengers <= 1}
      >
        -
      </button>
      <span className="font-bold text-lg text-black w-7 flex items-center justify-center">{userChoice.passengers}</span>
      <button
        onClick={incrementPassengers}
        className="text-white bg-ionic-primary rounded-lg p-1 w-8 h-8 flex items-center justify-center"
        aria-label="Increase passenger count"
        disabled={maxPassengers !== undefined && userChoice.passengers >= maxPassengers}
      >
        +
      </button>
    </div>
  );
};

export default PassengerCounter;
